export default __webpack_public_path__ + "static/media/what-we-provide-productstrategy-icon.660ea61d.svg";